import { IconNavigational24ColourPickerImg } from '@fabric-app/icons/svg';
import { ColorPicker } from '@fabric-app/ui/components/ColorPicker';
import { SearchBarButton } from './SearchbarButton';
import { searchBarMotionLayoutIdProps } from '../searchbar.config';

type SelectColorButtonProps = {
  color: string | undefined;
  onChange: (color: string | undefined) => void;
};

export const SelectColorButton: React.FC<SelectColorButtonProps> = ({ color, onChange }) => {
  return (
    <ColorPicker
      buttonElement={
        <SearchBarButton {...searchBarMotionLayoutIdProps.selectColorButton}>
          <IconNavigational24ColourPickerImg />
        </SearchBarButton>
      }
      key="color-picker"
      value={color}
      onChange={onChange}
    />
  );
};
